import { createReducer, on } from '@ngrx/store';

import { HydraulicSchematicActions } from './hydraulic-schematic.actions';
import { HydraulicSchematicState } from './hydraulic-schematic.state';

export const initHydraulicSchematicState = {
  loading: false,
  error: null,
  hydraulicSchematicSvgModel: null,
  hydraulicSchematicMapping: null,
};

export const hydraulicSchematicReducer = createReducer(
  initHydraulicSchematicState,

  on(
    HydraulicSchematicActions.getHydraulicSchematic.attempt,
    (state): HydraulicSchematicState => ({
      ...state,
      loading: true,
      error: null,
    })
  ),
  on(
    HydraulicSchematicActions.getHydraulicSchematic.error,
    (state, { error }): HydraulicSchematicState => ({
      ...state,
      loading: false,
      hydraulicSchematicSvgModel: null,
      error,
    })
  ),
  on(
    HydraulicSchematicActions.getHydraulicSchematic.success,
    (state, { hydraulicSchematicSvgModel }): HydraulicSchematicState => ({
      ...state,
      hydraulicSchematicSvgModel,
      loading: false,
      error: null,
    })
  ),
  on(
    HydraulicSchematicActions.getHydraulicSchematicMapping.attempt,
    (state): HydraulicSchematicState => ({
      ...state,
      error: null,
    })
  ),
  on(
    HydraulicSchematicActions.getHydraulicSchematicMapping.error,
    (state, { error }): HydraulicSchematicState => ({
      ...state,
      hydraulicSchematicMapping: null,
      error,
    })
  ),
  on(
    HydraulicSchematicActions.getHydraulicSchematicMapping.success,
    (state, { hydraulicSchematicMapping }): HydraulicSchematicState => ({
      ...state,
      hydraulicSchematicMapping,
      error: null,
    })
  ),
  on(
    HydraulicSchematicActions.clearState,
    (state): HydraulicSchematicState => ({
      ...state,
      loading: true,
      error: null,
      hydraulicSchematicSvgModel: null,
    })
  )
);
